// extracted by mini-css-extract-plugin
export default {"root":"SimplePrice-root-sK9"};